<div class="alert fh-alert {{ type | lowercase }}" role="alert">
  <div class="d-flex flex-row justify-content-center align-items-center">
    <i [class]="icon + ' fh-alert-icon me-4'"></i>
    <ui-fh-text [type]="'TEXT'" [text]="text"></ui-fh-text>
  </div>
</div>
